import { memo, useEffect, useRef } from 'react'

import { useQuery } from '@tanstack/react-query'

import { Editor, EditorInstance } from '@shared/components/Editor'
import { LoadingIndicator, NotFound } from '@shared/layouts'
import { useGatewayUpdateMutation } from 'hooks/mutations/origin'
import { rawRoute } from 'pages/NWPlatform/OriginGateways/Gateway/Routing'
import { gatewayQueryKeys } from 'services/queryKeys'

const JSONRaw = () => {
  const editorInstanceRef = useRef<EditorInstance>(undefined)

  const { gatewayId } = rawRoute.useParams()

  const gatewayQuery = useQuery(gatewayQueryKeys.detail({ gatewayId }))
  const { data: gateway } = gatewayQuery

  const { mutate } = useGatewayUpdateMutation()

  useEffect(() => {
    if (editorInstanceRef.current && gatewayQuery.isSuccess) {
      editorInstanceRef.current?.getModel()?.setValue(window.JSON.stringify(gateway, null, 4))
    }
  }, [gatewayQuery.isSuccess, gateway])

  if (gatewayQuery.isLoading) {
    return <LoadingIndicator />
  }

  if (!gateway) {
    return <NotFound />
  }

  return (
    <Editor
      value={gateway}
      onSubmit={(data, callbacks) => {
        mutate(
          {
            gatewayId,
            originGatewayEdit: data,
          },
          {
            onSuccess: callbacks.onSuccess,
            onError: callbacks.onError,
          },
        )
      }}
      getEditorInstance={(editorInstance: EditorInstance) => (editorInstanceRef.current = editorInstance)}
    />
  )
}

export const JSON = memo(JSONRaw)
